/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {refreshCardTabScheme} from '../api'

 export const useQueryRefreshCardTabScheme = createReactQueryHook('refreshCardTabScheme', refreshCardTabScheme)
